import { gql } from '@apollo/client'

const addressFragmet = ` _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone`

export const vendorAddressFragment = `vendorAddress{
      ${addressFragmet}
    }`

export const shipToAddressFragment = `shipToAddress{
      ${addressFragmet}
    }`

export const buildUpdatePurchaseOrderAddressQuery = (fragment = '') => {
  return gql(`
  mutation updatePurchaseOrderAddress($input: JSON!) {
    updatePurchaseOrderAddress(input: $input) {
      _id
      ${vendorAddressFragment}
      ${shipToAddressFragment}
      ${fragment}
    }
  }
`)
}

export const orderUpdatePurchaseOrderAddressQuery = buildUpdatePurchaseOrderAddressQuery()
